import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'div[jupiter-dashboard-loading]',
  standalone: true,
  template: `<div class="loading-dashboard">
    <img class="shine" src="/assets/images/logo/ts-logo.png" />
  </div> `,
  styleUrl: './dashboard-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JupiterDashboardLoadingComponent {}
